import { createStore, applyMiddleware, compose } from "redux";
import { thunk, withExtraArgument } from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "../store/reducers";
import createSagaMiddleware from "redux-saga";
import {
  watchAuth,
  watchAdmins,
  watchCategory,
  watchManageOptions,
  watchFrontEndUsers,
  watchMisc,
  watchCountries,
  watchSiteSettings,
  watchContentPage,
  watchAPIManagement,
  watchRevenue,
  watchRoles,
  watchMeta,
  watchTaxomony,
  watchSpamSetting,
  watchDashboard,
  watchCampaigns,
  watchAccreditation,
  watchCf3Questionnaire,
  watchIssuerVerification,
  watchActivities,
  watchEmailSettings,
  watchExportCSVList,
  watchWallet,
  saveInvestment,
  watchMangopay,
  userInvestment,
  watchNotificationTemplates,
  watchSecondaryMarket,
  watchSupport,
} from "../store/sagas";

const composeEnhancers =
  import.meta.env.NODE_ENV === "development"
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : null || compose;

const DEPLOYED_VERSION = import.meta.env.VITE_DEPLOYED_VERSION;
const currentPersistKey = `persist:root-${DEPLOYED_VERSION}`;

// Remove all old persisted versions from localStorage
Object.keys(localStorage).forEach((key) => {
  if (key.startsWith("persist:root") && key !== currentPersistKey) {
    localStorage.removeItem(key);
  }
});

const persistConfig = {
  key: `root-${DEPLOYED_VERSION}`,
  version: DEPLOYED_VERSION, // Store version info
  storage,
  migrate: async (state) => {
    if (state?._persist?.version !== DEPLOYED_VERSION) {
      return Promise.resolve(undefined); // Clear persisted state on version mismatch
    }
    return Promise.resolve(state);
  },
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk, sagaMiddleware))
);

const persistor = persistStore(store);

// ✅ Ensure persistor purges if the version key is missing
if (!localStorage.getItem(currentPersistKey)) {
  persistor.purge();
}

sagaMiddleware.run(watchAuth);
sagaMiddleware.run(watchAdmins);
sagaMiddleware.run(watchCategory);
sagaMiddleware.run(watchManageOptions);
sagaMiddleware.run(watchFrontEndUsers);
sagaMiddleware.run(watchMisc);
sagaMiddleware.run(watchCountries);
sagaMiddleware.run(watchSiteSettings);
sagaMiddleware.run(watchContentPage);
sagaMiddleware.run(watchAPIManagement);
sagaMiddleware.run(watchRevenue);
sagaMiddleware.run(watchRoles);
sagaMiddleware.run(watchMeta);
sagaMiddleware.run(watchTaxomony);
sagaMiddleware.run(watchSpamSetting);
sagaMiddleware.run(watchDashboard);
sagaMiddleware.run(watchCampaigns);
sagaMiddleware.run(watchAccreditation);
sagaMiddleware.run(watchCf3Questionnaire);
sagaMiddleware.run(watchIssuerVerification);
sagaMiddleware.run(watchActivities);
sagaMiddleware.run(watchEmailSettings);
sagaMiddleware.run(watchExportCSVList);
sagaMiddleware.run(watchWallet);
sagaMiddleware.run(saveInvestment);
sagaMiddleware.run(watchMangopay);
sagaMiddleware.run(userInvestment);
sagaMiddleware.run(watchNotificationTemplates);
sagaMiddleware.run(watchSecondaryMarket);
sagaMiddleware.run(watchSupport);

export default store;
export { persistor };
